export enum ClearingTicketChangeType {
  TICKET_CREATE = 'TICKET_CREATE',
  NOTE_ADD = 'NOTE_ADD',
  INTERNAL_NOTE_ADD = 'INTERNAL_NOTE_ADD',
  STATUS_CHANGE = 'STATUS_CHANGE',
  SEVERITY_CHANGE = 'SEVERITY_CHANGE',
  REQUESTED_RESOLUTION_DATE_CHANGE = 'REQUESTED_RESOLUTION_DATE_CHANGE',
  DATA_CHANGE = 'DATA_CHANGE',
  ATTACHMENT_ADD = 'ATTACHMENT_ADD',
  ASSIGNMENT_CHANGE = 'ASSIGNMENT_CHANGE',
}
